import { render, staticRenderFns } from "./VantagemItem.vue?vue&type=template&id=afd1a230&scoped=true&"
import script from "./VantagemItem.vue?vue&type=script&lang=js&"
export * from "./VantagemItem.vue?vue&type=script&lang=js&"
import style0 from "./VantagemItem.vue?vue&type=style&index=0&id=afd1a230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd1a230",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
